export default __webpack_public_path__ + "ed041dea7f493a5345ac6702cf7972cf.gif";